import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DefaultLayout } from '../../layouts';
// import PageForm from './components/page-form';
import PageResult from './components/page-result';
import QueryProvider from './hooks/provider';

const defaultFilterOptions = {
  keyword: true,
  location: true,
  type: true,
  date: true,
  category: false,
  category_resource: false,
  type_resource: false,
}

const Content = () => {
  const location = useLocation()
  const queryString = location.search
  const withQuery = queryString && queryString.length > 0
  const pageType = withQuery ? 'result' : 'form'
  const [ filterOptions, setFilterOptions ] = useState(defaultFilterOptions)

  useEffect(() => {
    let newFilterOptions = defaultFilterOptions
    const isResource = queryString.toLowerCase().includes('resource')
    const isBlog = queryString.toLowerCase().includes('blog')

    if(isResource){
      newFilterOptions = {
        keyword: true,
        location: true,
        type: true,
        date: true,
        category: false,
        category_resource: true,
        type_resource: true,
      }
    } else if(isBlog){
      newFilterOptions = {
        keyword: true,
        location: true,
        type: true,
        date: true,
        category: true,
        category_resource: false,
        type_resource: false,
      }
    }

    setFilterOptions(newFilterOptions)
  }, [queryString])


  return (
    <DefaultLayout>
      {
        pageType === 'result' ? (
          <PageResult filterOptions={filterOptions}/>
        ) : (
          // <PageForm />
          <PageResult filterOptions={filterOptions}/>
        )
      }
    </DefaultLayout>
  )
}

const SearchPage = () => {
  return (
    <QueryProvider>
      <Content />
    </QueryProvider>
  )
}

export default SearchPage
